export enum Role {
  ADMIN = 'admin',
  FLEET_MANAGER = 'fleet_manager',
  FLEET_VIEWER = 'fleet_viewer',
  HR_MANAGER = 'hr_manager',
  HR_VIEWER = 'hr_viewer',
  EQUIPMENT_MANAGER = 'equipment_manager',
  EQUIPMENT_VIEWER = 'equipment_viewer',
  NOTIFICATION_MANAGER = 'notification_manager',
  NOTIFICATION_VIEWER = 'notification_viewer',
  DOCUMENT_MANAGER = 'document_manager',
  DOCUMENT_VIEWER = 'document_viewer',
  EMPLOYEE = 'employee',
}

export const ROLE_LABELS: Record<Role, string> = {
  [Role.ADMIN]: 'Admin',
  [Role.FLEET_MANAGER]: 'Járműpark kezelő',
  [Role.FLEET_VIEWER]: 'Járműpark megtekintő',
  [Role.HR_MANAGER]: 'HR kezelő',
  [Role.HR_VIEWER]: 'HR megtekintő',
  [Role.EQUIPMENT_MANAGER]: 'Géppark kezelő',
  [Role.EQUIPMENT_VIEWER]: 'Géppark megtekintő',
  [Role.NOTIFICATION_MANAGER]: 'Értesítés kezelő',
  [Role.NOTIFICATION_VIEWER]: 'Értesítés megtekintő',
  [Role.DOCUMENT_MANAGER]: 'Dokumentum kezelő',
  [Role.DOCUMENT_VIEWER]: 'Dokumentum megtekintő',
  [Role.EMPLOYEE]: 'Dolgozó',
};
